exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search_total{padding:0 30px;border:1px solid #eeeeee;margin-bottom:20px}.search_total p,.search_total span{line-height:23px}.search_total>p{padding:10px 0}.child_page{padding:15px}.data_grid{border-bottom:1px solid #eeeeee}.data_grid p{padding:20px 0;text-align:center}.data_grid p:not(:first-child){border-left:1px solid #eeeeee}.data_grid p span:last-child{font-size:30px;line-height:40px}\n", ""]);

// exports
